import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-36 pb-24">
      <h1 className="text-[32px] font-bold text-secondary mb-6">Refund & Cancellation Policy</h1>
      
      <div className="space-y-6 text-[#555] text-[15px] leading-relaxed">
        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">1. Subscription Nature</h2>
          <p className="mb-2">All vendor listings on Top Interiors India are offered on a <strong>subscription basis (annual plans)</strong>.</p>
          <p>Once a vendor listing is activated, it provides <strong>immediate visibility and platform access</strong>, and therefore is considered a <strong>consumed digital service</strong>.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">2. No Refund Policy</h2>
          <p className="mb-2">All payments made for vendor listings (Professional / Premium plans) are <strong>non-refundable</strong>.</p>
          <p className="mb-2">This includes cases where:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>The vendor does not receive expected inquiries or business</li>
            <li>The vendor decides not to use the platform after activation</li>
            <li>The vendor provides incomplete information or delays profile submission</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">3. Cancellation Policy</h2>
          <p className="mb-2">Vendors may request cancellation of their listing at any time by contacting the support team.</p>
          <p className="mb-2">However:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Cancellation will <strong>not result in any refund</strong></li>
            <li>The listing will remain active until the end of the subscription period unless requested for removal</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">4. Early Termination by Platform</h2>
          <p className="mb-2">Top Interiors India reserves the right to suspend or terminate a vendor listing if:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>False or misleading information is provided</li>
            <li>Platform policies are violated</li>
            <li>Illegal or inappropriate content is uploaded</li>
          </ul>
          <p className="mt-2">In such cases, <strong>no refund will be provided</strong>.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">5. Exceptional Cases</h2>
          <p className="mb-2">Refunds, if any, will be considered only in exceptional situations such as:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Duplicate payment</li>
            <li>Technical error resulting in incorrect billing</li>
          </ul>
          <p className="mt-2">All such cases will be reviewed internally and processed at the discretion of Top Interiors India.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">6. Subscription Renewal</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Vendor subscriptions are valid for <strong>12 months from activation</strong></li>
            <li>Renewal is optional and must be initiated by the vendor</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">7. Contact for Support</h2>
          <p className="mb-2">For any queries related to cancellation or billing, vendors can contact:</p>
          <p className="flex items-center gap-2">
            <span>📧</span>
            <a href="mailto:support@topinteriorsindia.com" className="text-primary hover:underline">support@topinteriorsindia.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;
